import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import products from '../information/Products_v2';
import '../styles/product-detail.css';

export default function ProductDetail({ onNavigate }) {
  const { id } = useParams();
  const [billingCycle, setBillingCycle] = useState('monthly');

  const product = products.products.find((p) => p.id === id);

  if (!product) {
    return (
      <div className="product-detail-page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80vh' }}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontFamily: '"Helvetica Neue", sans-serif', color: '#0F1138', opacity: 0.5 }}>Producto no encontrado.</p>
          <button
            onClick={() => onNavigate('/products')}
            style={{ marginTop: '1rem', background: 'none', border: 'none', cursor: 'pointer', fontFamily: '"Helvetica Neue", sans-serif', fontSize: '14px', color: '#7275BB', textDecoration: 'underline' }}
          >
            ← Volver a productos
          </button>
        </div>
      </div>
    );
  }

  const isLive = product.status === 'live';
  const initial = product.title ? product.title.replace('Suko ', '')[0] : '?';

  const formatPrice = (tier) => {
    const price = billingCycle === 'yearly'
      ? (tier.price.yearly / 12)
      : tier.price.monthly;

    if (price === 0) return '0';
    return price.toFixed(2).replace('.', ',');
  };

  const yearlyNote = (tier) => {
    if (billingCycle !== 'yearly' || tier.price.yearly === 0) return null;
    const yearly = tier.price.yearly.toFixed(2).replace('.', ',');
    return `${yearly} € facturado anualmente`;
  };

  return (
    <div className="product-detail-page">

      {/* Hero */}
      <section className="product-detail-hero">
        <button
          className="product-detail-back"
          onClick={() => onNavigate('/products')}
        >
          ← Todos los productos
        </button>

        <div className="product-detail-hero-inner">
          <div
            className="product-detail-icon"
            style={{ backgroundColor: product.color }}
          >
            {product.image ? (
              <img src={product.image} alt={product.title} />
            ) : (
              initial
            )}
          </div>

          <p className="product-detail-label">SUKO APPS</p>
          <h1 className="product-detail-title fredoka-400">{product.title}</h1>
          <p className="product-detail-tagline">{product.tagline}</p>

          <div className="product-detail-badges">
            <span className={`product-detail-status ${isLive ? 'live' : 'coming-soon'}`}>
              {isLive ? 'Disponible' : 'Próximamente'}
            </span>
            {product.platforms && product.platforms.map((p, i) => (
              <span key={i} className="product-detail-platform">{p}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Highlights */}
      {product.highlights && (
        <section className="product-detail-highlights">
          <div className="product-detail-highlights-grid">
            {product.highlights.map((h, i) => (
              <div key={i} className="product-detail-highlight-card">
                <span className="product-detail-highlight-icon">{h.icon}</span>
                <p className="product-detail-highlight-label">{h.label}</p>
                <p className="product-detail-highlight-desc">{h.description}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Long description */}
      {product.longDescription && (
        <section className="product-detail-description-section">
          <p className="product-detail-section-label">Sobre el producto</p>
          <p className="product-detail-long-description">{product.longDescription}</p>
        </section>
      )}

      {/* Tiers */}
      {product.tiers && product.tiers.length > 0 && (
        <section className="product-detail-tiers-section">
          <div className="product-detail-tiers-inner">
            <div className="product-detail-tiers-header">
              <p className="product-detail-tiers-label">PLANES Y PRECIOS</p>
              <h2 className="product-detail-tiers-title fredoka-400">
                Elige el plan que mejor se adapta
              </h2>

              <div className="product-detail-billing-toggle">
                <button
                  className={`billing-toggle-btn ${billingCycle === 'monthly' ? 'active' : ''}`}
                  onClick={() => setBillingCycle('monthly')}
                >
                  Mensual
                </button>
                <button
                  className={`billing-toggle-btn ${billingCycle === 'yearly' ? 'active' : ''}`}
                  onClick={() => setBillingCycle('yearly')}
                >
                  Anual
                  <span className="billing-toggle-save">-20%</span>
                </button>
              </div>
            </div>

            <div className="product-detail-tiers-grid">
              {product.tiers.map((tier) => {
                const features = tier.featuresOverride || tier.features;
                const price = formatPrice(tier);
                const note = yearlyNote(tier);

                return (
                  <div
                    key={tier.id}
                    className={`tier-card ${tier.highlighted ? 'highlighted' : ''}`}
                    style={{ position: 'relative' }}
                  >
                    {tier.badge && (
                      <span className="tier-card-badge">{tier.badge}</span>
                    )}

                    <div className="tier-card-header">
                      <h3 className="tier-card-name">{tier.name}</h3>
                      <p className="tier-card-description">{tier.description}</p>
                    </div>

                    <div>
                      <div className="tier-card-price">
                        <span className="tier-price-currency">€</span>
                        <span className="tier-price-amount">{price}</span>
                        {tier.price.monthly > 0 && (
                          <span className="tier-price-period">/ mes</span>
                        )}
                      </div>
                      {note && <p className="tier-price-yearly-note">{note}</p>}
                      {tier.price.monthly === 0 && (
                        <p className="tier-price-yearly-note">Siempre gratis</p>
                      )}
                    </div>

                    <hr className="tier-card-divider" />

                    <ul className="tier-features-list">
                      {features.map((feature, fi) => (
                        <li
                          key={fi}
                          className={`tier-feature-item ${feature.included ? '' : 'excluded'}`}
                        >
                          <span className={`tier-feature-check ${feature.included ? 'yes' : 'no'}`}>
                            {feature.included ? '✓' : ''}
                          </span>
                          {feature.label}
                          {feature.note && (
                            <span style={{ opacity: 0.55, fontSize: '11px' }}> ({feature.note})</span>
                          )}
                        </li>
                      ))}
                    </ul>

                    <a
                      href={tier.cta.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="tier-card-cta"
                    >
                      {tier.cta.label}
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* Bottom CTA */}
      <section className="product-detail-open-section">
        <h2 className="product-detail-open-title fredoka-400">
          {isLive ? `¿Listo para empezar con ${product.title}?` : `${product.title} llegará pronto`}
        </h2>
        <p className="product-detail-open-sub">
          {isLive
            ? 'Accede a la aplicación y empieza a simplificar tu día a día.'
            : 'Estamos trabajando en ello. Contacta con nosotros para saber más o apuntarte a la lista de espera.'}
        </p>
        {isLive ? (
          <a
            href={product.url}
            target="_blank"
            rel="noopener noreferrer"
            className="product-detail-open-cta"
          >
            Abrir {product.title} ↗
          </a>
        ) : (
          <button
            onClick={() => onNavigate('/contact')}
            className="product-detail-open-cta"
            style={{ border: 'none', cursor: 'pointer' }}
          >
            Contactar ↗
          </button>
        )}
      </section>

    </div>
  );
}
